import PropTypes from 'prop-types';
import React from 'react';
import { cloudinaryBaseURL, iconSVGs } from './reactionBarSVGs';
import './ReactionIcons.scss';

export const HOVER = true;
export const NO_HOVER = false;
export const ACTIVE = true;
export const NOT_ACTIVE = false;

const iconColors = {};
iconColors[HOVER] = {};
iconColors[NO_HOVER] = {};
iconColors[HOVER][ACTIVE] = 'E7C2ED';
iconColors[HOVER][NOT_ACTIVE] = 'E7C2ED';
iconColors[NO_HOVER][ACTIVE] = 'E7C2ED';
iconColors[NO_HOVER][NOT_ACTIVE] = '95989c';

export { iconColors };

export default class ReactionIcons extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            hover: false,
        };
    }

    changeIconColorHover = () => {
        this.setState({
            hover: true,
        });
    };

    changeIconColorBack = () => {
        this.setState({
            hover: false,
        });
    };

    loadIconColor = () => {
        return iconColors[this.state.hover][this.props.active];
    };

    render() {
        const { active, type, onClick } = this.props;
        const activeStyle = active ? 'isActive' : 'inActive';
        const icon = iconSVGs[type](cloudinaryBaseURL(this.loadIconColor()))[
            active
        ];

        const iconSize = this.props.useSmallIcon ? 'smallIcon' : '';
        const className = `icons ${type} ${iconSize}`;

        return (
            <button
                type="button"
                data-qa={type}
                className={`component-Content-Image-ReactionIcons ${activeStyle} d-flex align-items-center`}
                onClick={onClick}
                onMouseEnter={this.changeIconColorHover}
                onMouseLeave={this.changeIconColorBack}
            >
                <img
                    className={className}
                    src={icon}
                    alt={`reaction-icon-${type}`}
                />
            </button>
        );
    }
}

ReactionIcons.propTypes = {
    // Type Of Icon
    type: PropTypes.oneOf([
        'like',
        'comment',
        'share',
        'flag',
        'interested',
        'delete',
        'edit',
    ]).isRequired,
    //  Whether someone has activated by clicking
    active: PropTypes.bool,
    // onClick Function
    onClick: PropTypes.func,
    useSmallIcon: PropTypes.bool,
};

ReactionIcons.defaultProps = {
    useSmallIcon: false,
    onClick: () => {},
    active: false,
};
